import Cookies from 'js-cookie';
const TokenKey = 'Admin-Token';

export default {
  getToken() {
    return Cookies.get(TokenKey, { path: '/' });
  },

  setToken(token) {
    Cookies.set(TokenKey, token, { path: '/', expires: 1 });
  },

  removeToken() {
    Cookies.remove(TokenKey, { path: '/' });
  },
};
